import { render, staticRenderFns } from "./BasicSwiper.vue?vue&type=template&id=8fa3db7c"
import script from "./BasicSwiper.vue?vue&type=script&lang=ts"
export * from "./BasicSwiper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports